import React, { Component, useRef, useState, useEffect } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import Cookies from 'universal-cookie';
import history from './history';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ReactHtmlParser from 'react-html-parser';
import { Editor } from '@tinymce/tinymce-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faBasketball, faBaseball, faBicycle, faChild, faCompactDisc, faCompass, faDice, faDumbbell, faFilePdf, faFootball, faFolderOpen, faFutbol, faGamepad, faHands, faHeartPulse, faHockeyPuck, faImage, faLayerGroup, faLeaf, faMoon, faPalette, faPeopleArrowsLeftRight, faPeopleGroup, faPersonArrowUpFromLine, faPersonFalling, faPersonRunning, faPersonSwimming, faPersonWalking, faPlus, faShoePrints, faStopwatch, faSun, faTableCellsLarge, faTrashCan, faVolleyball, faWater } from '@fortawesome/free-solid-svg-icons';
import Logo from './assets/Logo_EPS_300.png';

const cookies = new Cookies();

const Deconnexion = ({deconnexion}) => {
  return (
    <div className="eps-dashboard-logout-wrap">
      <button className="eps-dashboard-logout" onClick={(e) => {deconnexion()}}>
        <FontAwesomeIcon icon={faArrowRightFromBracket} aria-hidden="true" />
        <span>Déconnexion</span>
      </button>
    </div>
  )
}

const getCategorieIcon = (nom = '') => {
  const label = nom.toLowerCase();
  if (label.includes('basket')) return faBasketball;
  if (label.includes('football')) return faFutbol;
  if (label.includes('tchouk')) return faVolleyball;
  if (label.includes('rugby')) return faFootball;
  if (label.includes('indiaka')) return faCompactDisc;
  if (label.includes('hockey')) return faHockeyPuck;
  if (label.includes('entrer') || label.includes('nager')) return faPersonSwimming;
  if (label.includes('immerg')) return faWater;
  if (label.includes('équilibr') || label.includes('equilibr') || label.includes('déplac') || label.includes('deplac')) return faPersonWalking;
  if (label.includes('courir') || label.includes('course')) return faPersonRunning;
  if (label.includes('lancer')) return faBaseball;
  if (label.includes('manipul')) return faHands;
  if (label.includes('acro')) return faPeopleGroup;
  if (label.includes('gymnast') || label.includes('gymni')) return faPersonFalling;
  return faChild;
};

const isSportCategorie = (nom = '') => /basket|football|tchouk|rugby|indiaka|hockey/i.test(nom);

const getCompetenceIcon = (nom = '') => {
  const label = nom.toLowerCase();
  if (label.includes('performance') || label.includes('mesur')) return faStopwatch;
  if (label.includes('adapter') || label.includes('déplac') || label.includes('deplac')) return faPersonWalking;
  if (label.includes('coopér') || label.includes('cooper') || label.includes('oppos')) return faPeopleArrowsLeftRight;
  if (label.includes('expression') || label.includes('artist')) return faPalette;
  return faChild;
};

const getSequenceIcon = (nom = '') => {
  const label = nom.toLowerCase();
  if (label.includes('cour') || label.includes('course')) return faPersonRunning;
  if (label.includes('saut')) return faPersonArrowUpFromLine;
  if (label.includes('lanc')) return faBaseball;
  if (label.includes('combin')) return faLayerGroup;
  if (label.includes('nat')) return faPersonSwimming;
  if (label.includes('orient')) return faCompass;
  if (label.includes('vélo') || label.includes('velo')) return faBicycle;
  if (label.includes('basket')) return faBasketball;
  if (label.includes('football')) return faFutbol;
  if (label.includes('rugby')) return faFootball;
  if (label.includes('volley')) return faVolleyball;
  if (label.includes('opposition') || label.includes('coopér') || label.includes('cooper')) return faPeopleArrowsLeftRight;
  if (label.includes('tradition')) return faDice;
  return faChild;
};

const getWarmupIcon = (nom = '') => {
  const label = nom.toLowerCase();
  if (label.includes('réveil') || label.includes('reveil')) return faSun;
  if (label.includes('cardio') || label.includes('pulmo')) return faHeartPulse;
  if (label.includes('muscul')) return faDumbbell;
  if (label.includes('ludique')) return faGamepad;
  if (label.includes('articulaire')) return faPersonWalking;
  if (label.includes('retour au calme')) return faMoon;
  if (label.includes('calme')) return faLeaf;
  return faChild;
};

const normalizeAuthorFileName = (name = '') => {
  const normalized = String(name)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '');
  return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase() : '';
};

const AuthorLinks = ({routeFile, cycleSelected}) => {
  const prefix = normalizeAuthorFileName(routeFile);
  const cycleNumber = Number(cycleSelected);
  const routes = prefix && Number.isFinite(cycleNumber) && cycleNumber > 0
    ? [
      `/content-application/mot_des_auteurs/cycle${cycleNumber}/${encodeURIComponent(prefix)}1.pdf`,
      `/content-application/mot_des_auteurs/cycle${cycleNumber}/${encodeURIComponent(prefix)}2.pdf`
    ]
    : [];
  const [availableRoutes, setAvailableRoutes] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (routes.length === 0) {
      setAvailableRoutes([]);
      return () => { mounted = false; };
    }

    Promise.all(routes.map((route) => fetch(route, { method: 'HEAD', credentials: 'same-origin' })
      .then((response) => response.ok && (response.headers.get('content-type') || '').toLowerCase().includes('pdf'))
      .catch(() => false)))
      .then((availability) => {
        if (mounted) setAvailableRoutes(availability);
      });

    return () => { mounted = false; };
  }, [routeFile, cycleSelected]);

  if (routes.length === 0 || availableRoutes.every((available) => !available)) return null;

  return (
    <div className="eps-author-links" aria-label="Mots des auteurs">
      {availableRoutes[0] && <a className="eps-author-link" href={routes[0]} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFilePdf} aria-hidden="true" />
          <span>Mot des auteurs 1</span>
        </a>}
      {availableRoutes[1] && <a className="eps-author-link" href={routes[1]} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFilePdf} aria-hidden="true" />
          <span>Mot des auteurs 2</span>
        </a>}
    </div>
  );
};

const SelectionSkeleton = ({ variant = 'tile', count = 4 }) => (
  <div className={`eps-selection-skeleton eps-selection-skeleton--${variant}`} aria-label="Chargement">
    {Array.from({ length: count }).map((_, index) => <span key={index}><i /><b /></span>)}
  </div>
);

// Keep the placeholder visible long enough to preserve the layout even when
// the API responds from a warm/local cache almost immediately.
const MIN_SELECTION_LOADING_MS = 500;
const finishSelectionLoading = (startedAt, callback) => {
  const remaining = Math.max(0, MIN_SELECTION_LOADING_MS - (Date.now() - startedAt));
  window.setTimeout(callback, remaining);
};

const Dashboard = ({showModal,boolShow,categorieSelected}) => {
  var statut = cookies.get("statut")
  
  if(statut !== 'correcteur') {
    return (
      categorieSelected !== 0 ? <button className="eps-new-activity-button" type="button" onClick={(e) => {window.scroll(0,0); boolShow(showModal)}}><FontAwesomeIcon icon={faPlus} aria-hidden="true" /><span>Nouvelle activité</span></button> : null
    );
  } else {
    return (
      <div></div>
    )
  }
};

const Dashboard2 = ({showModalEchauffement,boolShowEchauffement,echauffementSelected}) => {
  var statut = cookies.get("statut")
  
  if(statut !== 'correcteur' && echauffementSelected > 0) {
    return (
      <button className="eps-new-activity-button" type="button" onClick={(e) => {window.scroll(0,0); boolShowEchauffement(showModalEchauffement)}}>
        <FontAwesomeIcon icon={faPlus} aria-hidden="true" />
        <span>Nouvel échauffement</span>
      </button>
    );
  } else {
    return null;
  }
};

const Dashboard3 = ({showModalCoinMaternelles,boolShowCoinMaternelles,coinMaternellesSelected}) => {
  var statut = cookies.get("statut")
  
  if(statut !== 'correcteur' && coinMaternellesSelected > 0) {
    return (
      <button className="eps-new-activity-button" type="button" onClick={(e) => {window.scroll(0,0); boolShowCoinMaternelles(showModalCoinMaternelles)}}>
        <FontAwesomeIcon icon={faPlus} aria-hidden="true" />
        <span>Nouveau coin</span>
      </button>
    );
  } else {
    return null;
  }
};

const SelectCycle = ({listeCycle,cycleSelected,buttonEchauffementSelected,buttonCoinMaternellesSelected,changeCycle,loadEchauffement,loadCoinMaternelles,loading}) => {
  let listButton = []

  Array.from(listeCycle).forEach(value => {
    var cycle = value["nom"].split(' ')
    listButton.push(<button type="button" className={cycleSelected === value["id_cycle"] ? "eps-cycle-button is-selected" : "eps-cycle-button"} key={"cycles" + value["id_cycle"]} onClick={(e) => {changeCycle(value["id_cycle"])}}><FontAwesomeIcon icon={faChild} aria-hidden="true" /><span className="eps-cycle-label">{cycle[0]}</span><span className="eps-cycle-number">{cycle[1]}</span></button>)
  });

  return (
    <div className="eps-selector-row">
      <div className="eps-cycle-panel">{loading ? <SelectionSkeleton variant="cycle" count={3} /> : listButton}</div>
      <div className="eps-resource-panel">
        <button className={cycleSelected === null && buttonEchauffementSelected === false ? "eps-resource-card is-selected" : "eps-resource-card"} onClick={(e) => {loadCoinMaternelles()}}>
          <FontAwesomeIcon icon={faChild} aria-hidden="true" />
          <span>Coin des maternelles</span>
        </button>
        <button className={cycleSelected === null && buttonCoinMaternellesSelected === false ? "eps-resource-card is-selected" : "eps-resource-card"} onClick={(e) => {loadEchauffement()}}>
          <FontAwesomeIcon icon={faShoePrints} aria-hidden="true" />
          <span>Échauffement</span>
        </button>
        <button className="eps-resource-card" onClick={(e) => {window.open("/image")}}>
          <FontAwesomeIcon icon={faImage} aria-hidden="true" />
          <span>Image</span>
        </button>
      </div>
    </div>
  )
}

const SelectCompetence = ({listeCompetence,competenceSelected,changeCompetence,loading,reserve}) => {
  let listButton = []

  Array.from(listeCompetence).forEach(value => {
    listButton.push(<div className="row" key={"competence" + value["id_competence"]}><button type="button" className={competenceSelected === value["id_competence"] ? "cardCompetenceSelected" : "cardCompetence"} onClick={(e) => {changeCompetence(value["id_competence"])}}><div className="contentIcon"><FontAwesomeIcon className="icon-competence" icon={getCompetenceIcon(value["nom"])} aria-hidden="true" /></div>{value["nom"]}</button></div>)
  });

  const visible = listButton.length > 0 || loading || reserve;

  return (
    <div className={visible ? "col-md-12" : "col-md-12 hide"}>
      <div className="col-md-12 allCycle">
        {loading || (reserve && listButton.length === 0) ? <SelectionSkeleton variant="tile" count={4} /> : listButton}
      </div>
    </div>
  )
}

const SelectEchauffement = ({listeEchauffement,echauffementSelected,changeEchauffement,loading}) => {
  let listButton = []

  Array.from(listeEchauffement).forEach(value => {
    listButton.push(<div className="row" key={"echauffement" + value["id"]}><button type="button" className={echauffementSelected === value["id"] ? "cardCompetenceSelected" : "cardCompetence"} onClick={(e) => {changeEchauffement(value["id"])}}><div className="contentIcon"><FontAwesomeIcon className="icon-competence" icon={getWarmupIcon(value["nom"])} aria-hidden="true" /></div>{value["nom"]}</button></div>)
  });

  const visible = listButton.length > 0 || loading;

  return (
    <div className={visible ? "col-md-12" : "col-md-12 hide"}>
      <div className="col-md-12 allCycle">
        {loading ? <SelectionSkeleton variant="tile" count={4} /> : listButton}
      </div>
    </div>
  )
}

const SelectCoinMaternelles = ({listeCoinMaternelles,coinMaternellesSelected,changeCoinMaternelles,loading}) => {
  let listButton = []

  Array.from(listeCoinMaternelles).forEach(value => {
    listButton.push(<div className="row" key={"coin_maternelles" + value["id"]}><button type="button" className={coinMaternellesSelected === value["id"] ? "cardCompetenceSelected" : "cardCompetence"} onClick={(e) => {changeCoinMaternelles(value["id"])}}><div className="contentIcon"><FontAwesomeIcon className="icon-competence" icon={getWarmupIcon(value["nom"])} aria-hidden="true" /></div>{value["nom"]}</button></div>)
  });

  const visible = listButton.length > 0 || loading;

  return (
    <div className={visible ? "col-md-12" : "col-md-12 hide"}>
      <div className="col-md-12 allCycle">
        {loading ? <SelectionSkeleton variant="tile" count={4} /> : listButton}
      </div>
    </div>
  )
}

const SelectSequence = ({listeSequence,sequenceSelected,changeSequence,loading,reserve}) => {
  let listButton = []
  const sequenceTrackRef = useRef(null)
  const [hasSequenceOverflow, setHasSequenceOverflow] = useState(false)

  Array.from(listeSequence).forEach(value => {
    listButton.push(<div className={`row displaySequence${sequenceSelected === value["id_sequence"] ? ' is-selected' : ''}`} key={"sequence" + value["id_sequence"]}><button type="button" className={sequenceSelected === value["id_sequence"] ? "cardSequenceSelected" : "cardSequence"} onClick={(e) => {changeSequence(value["id_sequence"],value["nom"])}}><FontAwesomeIcon className="eps-sequence-icon" icon={getSequenceIcon(value["nom"])} aria-hidden="true" /><p className="textSequence">{value["nom"]}</p></button></div>)
  });

  const visible = listButton.length > 0 || loading || reserve;

  useEffect(() => {
    const track = sequenceTrackRef.current;
    if (!track) return undefined;

    const updateOverflow = () => setHasSequenceOverflow(track.scrollWidth > track.clientWidth + 1);
    updateOverflow();
    window.addEventListener('resize', updateOverflow);
    return () => window.removeEventListener('resize', updateOverflow);
  }, [listButton.length, loading, reserve]);

  return (
    <div className={visible ? "col-md-12 allCycle" : "col-md-12 hide"}>
      <div className="eps-sequence-carousel">
        {hasSequenceOverflow && <button className="eps-carousel-arrow" type="button" aria-label="Séquences précédentes" onClick={() => sequenceTrackRef.current && sequenceTrackRef.current.scrollBy({ left: -280, behavior: 'smooth' })}>‹</button>}
        <div className="eps-sequence-track" ref={sequenceTrackRef}>
          {loading || (reserve && listButton.length === 0) ? <SelectionSkeleton variant="sequence" count={4} /> : listButton}
        </div>
        {hasSequenceOverflow && <button className="eps-carousel-arrow" type="button" aria-label="Séquences suivantes" onClick={() => sequenceTrackRef.current && sequenceTrackRef.current.scrollBy({ left: 280, behavior: 'smooth' })}>›</button>}
      </div>
    </div>
  )
}

const SelectCategorie = ({listeCategorie,categorieSelected,changeCategorie,showModal,boolShow,onClickHandler3,onChangeHandler3,loading,reserve}) => {
  let listButton = []
  let hasSportCategories = false

  Array.from(listeCategorie).forEach(value => {
    const selected = categorieSelected === value["id_categorie"];
    const sportCategory = isSportCategorie(value["nom"]);
    hasSportCategories = hasSportCategories || sportCategory;
    const activateCategorie = () => changeCategorie(value["id_categorie"]);
    listButton.push(<div className={`row buttonCategorie${selected ? ' is-selected' : ''}${sportCategory ? ' is-sport' : ''}`} key={"categorie" + value["id_categorie"]} role="button" tabIndex="0" onClick={activateCategorie} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activateCategorie(); } }}><button type="button" aria-label={value["nom"]} onClick={(e) => { e.stopPropagation(); activateCategorie(); }} className={selected ? "cardCategorieSelected" : "cardCategorie"}><FontAwesomeIcon icon={getCategorieIcon(value["nom"])} aria-hidden="true" /></button><p className="">{value["nom"]}</p></div>)
  });

  let visible = listButton.length > 0 || loading || reserve
  let visible2 = categorieSelected === -1 ? true : false

  if (visible === true) {
    return (
      <div className={visible ? "col-md-12" : "col-md-12 hide" }>
        <React.Fragment>
          <div className={`col-md-12 allCycle categoryCycle${hasSportCategories ? ' sportCycle' : ''}`}>
            {loading || (reserve && listButton.length === 0) ? <SelectionSkeleton variant="category" count={hasSportCategories ? 6 : 3} /> : listButton}
          </div>
        </React.Fragment>
      </div>
    );
  } else {
    return (
      <div className={visible2 ? "col-md-12" : "col-md-12 hide" }>
        <React.Fragment>
          <div className="col-md-12">
            <div className="col-md-4 ">
              <button className="btn btn-success create" onClick={(e) => {window.scroll(0,0); boolShow(showModal)}}><i className="fas fa-plus faicon"></i>nouvelle activité</button>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  } 
}

const DisplaySeance = ({detailSeance,showSeance,showCroquis,showMateriel,sequenceSelected,listeSequence,activiteSelected,displayCroquis,displayMateriel,displaySeance2,numBubble}) => {
  if(detailSeance) {
    let croquis = JSON.parse(detailSeance[0].croquis)
    let allCroquis = []
    let variable = JSON.parse(detailSeance[0].variable)
    let allVariable = []
    let materiel = JSON.parse(detailSeance[0].materiel)
    let allMateriel = []
    var key
    const content = detailSeance[0].descriptif

    for(key in croquis) {
      allCroquis.push(
        <div key={"modalCroquis"+key} style={{'marginTop': '80px'}}>
          <div className="consigneNumberLine">
            <img className="centerText imgModalWidth" alt="croquis" src={croquis[key]['croquis']} />
          </div>
          <div className="col-md-12">
            <p className="noMargin" style={{ 'textAlign': 'center', 'color': '#4CA9B3'}}>{croquis[key]['legende']}</p>
          </div>
        </div>
      )
    }

    for(key in variable) {
      allVariable.push(
        <div key={"modalVar"+key}>
          <div>
            <p className="noMargin">- {variable[key]}</p>
          </div>
        </div>
      )
    }

    for(key in materiel) {
      allMateriel.push(
        <div key={"ModalMat"+key} className='col-md-6'>
          <div className='col-md-12'>
            <a target={materiel[key]['materiel'].match(/.pdf/g) ? "_blank" : ""} href={materiel[key]['materiel'].match(/.pdf/g) ? materiel[key]['materiel'] : '#'}>
              <img className="noMargin" style={{'height':'100px','marginLeft':'auto','marginRight':'auto','display':'block'}} src={materiel[key]['materiel'].match(/.pdf/g) ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : materiel[key]['materiel']} alt="materiel"/>
            </a>
          </div>
          <div className="col-md-12">
            <p className="noMargin" style={{ 'textAlign': 'center', 'color': '#4CA9B3'}}>{materiel[key]['legende']}</p>
          </div>
        </div>
      )
    }

    return (
      <div className="fullWidth">
        <Fade left when={showSeance}>
          <div className={showSeance === true ? "fullWidth displayBlock" : "fullWidth displayNone"}>
            <div className="col-md-12 displaySeanceHeader">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Activité</span>
                    <span className="numBubble">{numBubble}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{detailSeance[0].titre_activite}</p>
                  <p className="titleActivityBubble2">Objectif: <span className="whiteText">{detailSeance[0].objectif}</span></p>
                </div>
                <div className="col-md-2 materielPicto" onClick={(e) => {displayMateriel()}}>
                  <div><img className="btnBottom2" alt="btn2" src="./btn2_white.png" /></div>
                </div>
            </div>
            <div className="col-md-12 displaySeanceBody">
              <div className="consigneNumberLine" style={{'display': 'block'}}>
                {ReactHtmlParser(content)}
              </div>
              <div className="divVariable" style={allVariable.length === 0 ? {'display':'none'} : {'display':'block'}}>
                <div className="col-md-12 contentDivVariable">
                  <span className="maintenanceImg"></span>
                  <p className="textTitleVariable">Variables</p>
                  <div className="col-md-12 allVariable">
                    {allVariable}
                  </div>
                </div>
              </div>
              <div className="bottomBar col-md-12">
                <div className="row contentHeight">
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayCroquis()}}>
                    <div><img className="btnBottom1" alt="btn1" src="./btn1.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayMateriel()}}>
                    <div><img className="btnBottom2" alt="btn2" src="./btn2.png" /></div>
                  </div>
                  <div className="col-md-4 noPadding3">
                    <div className="homeBtn"><img className="btnBottom3" alt="btn3" src="./btn3.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3">
                    <div><img className="btnBottom4" alt="btn4" src="./btn4.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displaySeance2()}}>
                    <div><img className="btnBottom5" alt="btn5" src="./btn5.png" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
        <Fade left when={showCroquis}>
          <div className={showCroquis === true ? "fullWidth displayBlock" : "fullWidth displayNone"}>
            <div className="col-md-12 displaySeanceBody">
              <div className="col-md-12 displaySeanceHeaderMateriel">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Activité</span>
                    <span className="numBubble">{numBubble}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{detailSeance[0].titre_activite}</p>
                  <p className="titleActivityBubble2">Objectif: <span className="whiteText">{detailSeance[0].objectif}</span></p>
                </div>
                <div className="col-md-2 materielPicto" onClick={(e) => {displayMateriel()}}>
                  <div><img className="btnBottom2" alt="btn2" src="./btn2_white.png" /></div>
                </div>
              </div>
              <div className="topHeaderOrganisation">
                <span className="materielTitle">Organisation spatiale</span>
              </div>
              <div>
                {allCroquis}
              </div>
              <div className="bottomBar col-md-12">
                <div className="row contentHeight">
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayCroquis()}}>
                    <div><img className="btnBottom1" alt="btn1" src="./btn1.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayMateriel()}}>
                    <div><img className="btnBottom2" alt="btn2" src="./btn2.png" /></div>
                  </div>
                  <div className="col-md-4 noPadding3">
                    <div className="homeBtn"><img className="btnBottom3" alt="btn3" src="./btn3.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3">
                    <div><img className="btnBottom4" alt="btn4" src="./btn4.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displaySeance2()}}>
                    <div><img className="btnBottom5" alt="btn5" src="./btn5.png" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
        <Fade left when={showMateriel}>
          <div className={showMateriel === true ? "fullWidth displayBlock" : "fullWidth displayNone"}>
            <div className="col-md-12 displaySeanceBody row">
              <div className="col-md-12 displaySeanceHeaderMateriel">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Activité</span>
                    <span className="numBubble">{numBubble}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{detailSeance[0].titre_activite}</p>
                  <p className="titleActivityBubble2">Objectif: <span className="whiteText">{detailSeance[0].objectif}</span></p>
                </div>
                <div className="col-md-2 materielPicto" onClick={(e) => {displayMateriel()}}>
                  <div><img className="btnBottom2" alt="btn2" src="./btn2_white.png" /></div>
                </div>
              </div>
              <div className="topHeaderMateriel">
                <img className="materielTitleImg" src="btn2_blue.png" alt="btn2blue" />
                <span className="materielTitle">Le matériel</span>
              </div>
              {allMateriel}
              <div className="bottomBar col-md-12">
                <div className="row contentHeight">
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayCroquis()}}>
                    <div><img className="btnBottom1" alt="btn1" src="./btn1.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displayMateriel()}}>
                    <div><img className="btnBottom2" alt="btn2" src="./btn2.png" /></div>
                  </div>
                  <div className="col-md-4 noPadding3">
                    <div className="homeBtn"><img className="btnBottom3" alt="btn3" src="./btn3.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3">
                    <div><img className="btnBottom4" alt="btn4" src="./btn4.png" /></div>
                  </div>
                  <div className="col-md-2 noPadding3" onClick={(e) => {displaySeance2()}}>
                    <div><img className="btnBottom5" alt="btn5" src="./btn5.png" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    )
  } else {
    return (<div className=""></div>);
  }
};

const DisplayEchauffement = ({detailSeanceEchauffement,showEchauffement2,selectedEchauffement,numBubble}) => {
  if(detailSeanceEchauffement) {
    let variable = JSON.parse(detailSeanceEchauffement[0].variable)
    let allVariable = []

    var key
    const content = detailSeanceEchauffement[0].descriptif

    for(key in variable) {
      allVariable.push(
        <div key={"modalVar"+key}>
          <div>
            <p className="noMargin">- {variable[key]}</p>
          </div>
        </div>
      )
    }

    return (
      <div className="fullWidth">
        <Fade left when={showEchauffement2}>
          <div className={showEchauffement2 === true ? "fullWidth displayBlock" : "fullWidth displayNone"}>
            <div className="col-md-12 displaySeanceHeader">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Echauffement</span>
                    <span className="numBubble">{numBubble}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{detailSeanceEchauffement[0].titre_activite}</p>
                </div>
            </div>
            <div className="col-md-12 displaySeanceBody">
              <div className="consigneNumberLine" style={{'display': 'block'}}>
                {ReactHtmlParser(content)}
              </div>
              <div className="divVariable" style={allVariable.length === 0 ? {'display':'none'} : {'display':'block'}}>
                <div className="col-md-12 contentDivVariable">
                  <span className="maintenanceImg"></span>
                  <p className="textTitleVariable">Variables</p>
                  <div className="col-md-12 allVariable">
                    {allVariable}
                  </div>
                </div>
              </div>
              <div className="bottomBar col-md-12">
                <div className="row contentHeight">
                  <div className="col-md-4 noPadding3">
                    <div className="homeBtn" style={{ 'marginLeft' : '145px' }}><img className="btnBottom3" alt="btn3" src="./btn3.png" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    )
  } else {
    return (<div className=""></div>);
  }
};

const DisplayCoinMaternelles = ({detailSeanceCoinMaternelles,showCoinMaternelles2,selectedCoinMaternelles,numBubble}) => {
  if(detailSeanceCoinMaternelles) {
    let variable = JSON.parse(detailSeanceCoinMaternelles[0].variable)
    let allVariable = []

    var key
    const content = detailSeanceCoinMaternelles[0].descriptif

    for(key in variable) {
      allVariable.push(
        <div key={"modalVar"+key}>
          <div>
            <p className="noMargin">- {variable[key]}</p>
          </div>
        </div>
      )
    }

    return (
      <div className="fullWidth">
        <Fade left when={showCoinMaternelles2}>
          <div className={showCoinMaternelles2 === true ? "fullWidth displayBlock" : "fullWidth displayNone"}>
            <div className="col-md-12 displaySeanceHeader">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Coin des maternelles</span>
                    <span className="numBubble">{numBubble}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{detailSeanceCoinMaternelles[0].titre_activite}</p>
                </div>
            </div>
            <div className="col-md-12 displaySeanceBody">
              <div className="consigneNumberLine" style={{'display': 'block'}}>
                {ReactHtmlParser(content)}
              </div>
              <div className="divVariable" style={allVariable.length === 0 ? {'display':'none'} : {'display':'block'}}>
                <div className="col-md-12 contentDivVariable">
                  <span className="maintenanceImg"></span>
                  <p className="textTitleVariable">Variables</p>
                  <div className="col-md-12 allVariable">
                    {allVariable}
                  </div>
                </div>
              </div>
              <div className="bottomBar col-md-12">
                <div className="row contentHeight">
                  <div className="col-md-4 noPadding3">
                    <div className="homeBtn" style={{ 'marginLeft' : '145px' }}><img className="btnBottom3" alt="btn3" src="./btn3.png" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    )
  } else {
    return (<div className=""></div>);
  }
};

const parseActivityData = (value) => {
  if (!value) return {};
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value) || {};
  } catch (e) {
    return {};
  }
};

const ActivityDetailModal = ({show, onHide, detail, type, numBubble}) => {
  if (!detail) return null;

  const variables = parseActivityData(detail.variable);
  const materiel = parseActivityData(detail.materiel);
  const croquis = parseActivityData(detail.croquis);
  const typeLabel = type === 'echauffement' ? 'Échauffement' : type === 'coin' ? 'Coin des maternelles' : 'Activité';
  const variableItems = Object.keys(variables).map((key) => (
    <li key={`activity-variable-${key}`}>{variables[key]}</li>
  ));
  const materialItems = Object.keys(materiel).map((key) => {
    const item = materiel[key] || {};
    const materialUrl = typeof item.materiel === 'string' ? item.materiel : '';
    if (!materialUrl && !item.legende) return null;
    return (
      <div className="activity-view-material" key={`activity-material-${key}`}>
        {materialUrl && <a href={materialUrl.match(/\.pdf/i) ? materialUrl : '#'} target={materialUrl.match(/\.pdf/i) ? '_blank' : undefined} rel="noreferrer">
          <img src={materialUrl.match(/\.pdf/i) ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : materialUrl} alt={item.legende || 'Matériel'} />
        </a>}
        {item.legende && <p>{item.legende}</p>}
      </div>
    );
  }).filter(Boolean);
  const sketchItems = Object.keys(croquis).map((key) => {
    const item = croquis[key] || {};
    const sketchUrl = typeof item.croquis === 'string' ? item.croquis : '';
    if (!sketchUrl && !item.legende) return null;
    return (
      <div className="activity-view-sketch" key={`activity-sketch-${key}`}>
        {sketchUrl && <img src={sketchUrl} alt={item.legende || 'Organisation spatiale'} />}
        {item.legende && <p>{item.legende}</p>}
      </div>
    );
  }).filter(Boolean);

  return (
    <div className={`activity-view-modal-backdrop${show ? ' is-open' : ''}`} onMouseDown={(e) => { if (e.target === e.currentTarget) onHide(); }}>
      <div className="activity-view-modal" role="dialog" aria-modal="true" aria-labelledby="activity-view-title" onMouseDown={(e) => e.stopPropagation()}>
        <div className="activity-view-modal-header">
          <div className="activity-view-modal-kicker"><span>{typeLabel}</span>{numBubble ? <span className="activity-view-modal-number">{numBubble}</span> : null}</div>
          <button type="button" className="activity-view-modal-close" aria-label="Fermer" onClick={onHide}>×</button>
          <h2 id="activity-view-title">{detail.titre_activite || detail.titre || 'Activité'}</h2>
          {detail.objectif && <p className="activity-view-objective"><strong>Objectif :</strong> {detail.objectif}</p>}
        </div>
        <div className="activity-view-modal-body">
          {detail.descriptif && <section className="activity-view-section"><h3>Description</h3><div className="activity-view-rich-content">{ReactHtmlParser(detail.descriptif)}</div></section>}
          {variableItems.length > 0 && <section className="activity-view-section"><h3>Variables</h3><ul>{variableItems}</ul></section>}
          {sketchItems.length > 0 && <section className="activity-view-section"><h3>Organisation spatiale</h3><div className="activity-view-sketch-grid">{sketchItems}</div></section>}
          {materialItems.length > 0 && <section className="activity-view-section"><h3>Matériel</h3><div className="activity-view-material-grid">{materialItems}</div></section>}
        </div>
        <div className="activity-view-modal-footer"><button type="button" className="btn btn-primary" onClick={onHide}>Fermer</button></div>
      </div>
    </div>
  );
};

const ActivityDeleteConfirmation = ({deletion, onCancel, onConfirm}) => {
  if (!deletion) return null;
  return (
    <div className="activity-delete-backdrop" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="activity-delete-dialog" role="dialog" aria-modal="true" aria-labelledby="activity-delete-title" onMouseDown={(e) => e.stopPropagation()}>
        <h2 id="activity-delete-title">Confirmer la suppression</h2>
        <p>Voulez-vous vraiment supprimer cette activité&nbsp;?</p>
        {deletion.name && <p className="activity-delete-name">« {deletion.name} »</p>}
        <p className="activity-delete-warning">Cette action est irréversible.</p>
        <div className="activity-delete-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Annuler</button>
          <button type="button" className="btn btn-danger" onClick={onConfirm}>Supprimer définitivement</button>
        </div>
      </div>
    </div>
  );
};

const NewSeanceModal = ({modalKey,initialValue,csvMateriel,content,handleEditorChange,showModal,boolShow,nbMateriel,nbVariable,nbCroquis,listMateriel,listVariable,nbMaterielInc,nbVariableInc,nbCroquisInc,createSeance,checkonChange,onDrop,onDrop2,changeCroquis,croquisSected}) => {
  let objectif
  let inputMateriel = []
  let inputVariable = []
  let inputCroquis = []
  var i = 0
  let titreActivite = ''

  for(i=0;nbMateriel > i; i++) {
    inputMateriel.push(<div key={"materiel"+i} className="modal-edit-row"><img src={csvMateriel[i] !== undefined ? (csvMateriel[i]['materiel'].match(/.pdf/g) ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : csvMateriel[i]['materiel'] !== "" ? csvMateriel[i]['materiel'] : "https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg" ) : 'https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg'} className="materielInput imageMateriel" alt="materiel" /><label className="modal-input-group">Lien du matériel<input type="text" name={i} placeholder={"Matériel " + (i+1)} className="form-control inputFile materielInput" onChange={(e) => {listMateriel(e.target.name, e.target.value, 'materiel')}} /></label><label className="modal-input-group">Légende<input type="text" name={i} placeholder={"Légende " + (i+1)} className="form-control inputFile materielInput" onChange={(e) => {listMateriel(e.target.name, e.target.value, 'legende')}} /></label><button type="button" aria-label="Supprimer le matériel" title="Supprimer" className="btn btn-danger btn-in-modal" onClick={(e) => {nbMaterielInc(nbMateriel,-1)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  }

  for(i=0;nbVariable > i; i++) {
    inputVariable.push(<div key={"variable"+i} className="modal-edit-row"><label className="modal-input-group"><input key={"variable"+i} type="text" name={i} placeholder={"Variable " + (i+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,-1)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  }

  for(i=0;nbCroquis > i; i++) {
    inputCroquis.push(<div key={"croquis" + i} className="modal-edit-row"><img src={croquisSected[i] !== undefined ? croquisSected[i]['croquis'] !== "" ? croquisSected[i]['croquis'] : "https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg" : "https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg"} className="materielInput imageMateriel" alt="croquis" /><label className="modal-input-group">Lien du croquis<input type="text" name={i} placeholder={"Croquis"} className="form-control inputFile materielInput" onChange={(e) => {changeCroquis(e.target.name, e.target.value, 'croquis')}} /></label><label className="modal-input-group">Légende<input type="text" name={i} placeholder={"Légende"} className="form-control inputFile materielInput" onChange={(e) => {changeCroquis(e.target.name, e.target.value, 'legende')}} /></label><button type="button" aria-label="Supprimer le croquis" title="Supprimer" className="btn btn-danger btn-in-modal" onClick={(e) => {nbCroquisInc(nbCroquis,-1)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  }

  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog key="editor12" className={showModal === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Nouvelle activité</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre de l’activité</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" placeholder="Titre activité" ref={titreActiviteValue => {
              titreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field"><span className="modal-label-text">Objectif</span><textarea id={modalKey + 'objectif'} key={modalKey + 'objectif'} type="text" className="form-control textArea1" placeholder="Objectif" ref={objectifValue => {
              objectif = objectifValue
            }}/></label>
            <label className="modal-field-label">Description de l’activité</label>
            <div>

              <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                initialValue='Nouveau'
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               // onEditorChange={(e) => { contentValue = e}}
             />
            </div>
            <br />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,1)}}>Ajouter une variable</button>
            </div>
            <div className="modal-section">
              <div className="modal-section-label">Croquis</div>
              <button className="btn btn-success btn-in-modal" onClick={(e) => {nbCroquisInc(nbCroquis,1)}}>Ajouter un croquis</button>
              {inputCroquis}
            </div>
            <div className="modal-section">
              <div className="modal-section-label">Matériel</div>{inputMateriel}
            </div>
            <button className="btn btn-success btn-in-modal" onClick={(e) => {nbMaterielInc(nbMateriel,1)}}>Ajouter un matériel</button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { createSeance(titreActivite.value,objectif.value,content) }}>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShow(showModal); }}>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};


const NewSeanceModal2 = ({modalKey,initialValue,content,handleEditorChange,showModalEchauffement,boolShowEchauffement,nbVariable,listVariable,nbVariableInc,createEchauffement,checkonChange,onDrop,onDrop2}) => {
  let inputVariable = []
  var i = 0
  let titreActivite = ''

  for(i=0;nbVariable > i; i++) {
    inputVariable.push(<div key={"variable"+i} className="modal-edit-row"><label className="modal-input-group"><input key={"variable"+i} type="text" name={i} placeholder={"Variable " + (i+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,-1)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  }

  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog key="editor12" className={showModalEchauffement === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Nouvel échauffement</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre de l’échauffement</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" placeholder="Titre échauffement" ref={titreActiviteValue => {
              titreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field-label">Description de l’échauffement</label>
            <div>

              <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                initialValue='Nouveau'
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               // onEditorChange={(e) => { contentValue = e}}
             />
            </div>
            <br />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,1)}}>Ajouter une variable</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { createEchauffement(titreActivite.value,content) }}>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShowEchauffement(showModalEchauffement); }}>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

const NewSeanceModal3 = ({modalKey,initialValue,content,handleEditorChange,showModalCoinMaternelles,boolShowCoinMaternelles,nbVariable,listVariable,nbVariableInc,createCoinMaternelles,checkonChange,onDrop,onDrop2}) => {
  let inputVariable = []
  var i = 0
  let titreActivite = ''

  for(i=0;nbVariable > i; i++) {
    inputVariable.push(<div key={"variable"+i} className="modal-edit-row"><label className="modal-input-group"><input key={"variable"+i} type="text" name={i} placeholder={"Variable " + (i+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,-1)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  }

  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog key="editor12" className={showModalCoinMaternelles === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Nouveau coin</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre du coin</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" placeholder="Titre coin" ref={titreActiviteValue => {
              titreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field-label">Description du coin</label>
            <div>

              <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                initialValue='Nouveau'
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               // onEditorChange={(e) => { contentValue = e}}
             />
            </div>
            <br />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => {nbVariableInc(nbVariable,1)}}>Ajouter une variable</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { createCoinMaternelles(titreActivite.value,content) }}>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShowCoinMaternelles(showModalCoinMaternelles); }}>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

const ModifSeance = ({modalKey,initialValue,content,handleEditorChange,modifId,titre_activite,objectif,csvMateriel,csvVariable,showModal3,boolShow3,nbMateriel,nbVariable,nbCroquis,listMateriel,listVariable,nbMaterielInc,nbVariableInc,nbCroquisInc,modifSeance,checkonChange,onDrop,onDrop2,croquisSected,changeCroquis}) => {
  let inputMateriel = []
  let inputVariable = []
  let inputCroquis = []
  let tmpTitreActivite = titre_activite
  let tmpObjectif = objectif

  Object.keys(csvMateriel).map((key, index) => (
    inputMateriel.push(<div key={"materiel"+index} className="modal-edit-row"><img src={csvMateriel[key] !== undefined ? (csvMateriel[key]['materiel'].match(/.pdf/g) ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : csvMateriel[key]['materiel']) : 'https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg'} className="materielInput imageMateriel" alt="materiel" /><label className="modal-input-group">Lien du matériel<input type="text" name={key} value={csvMateriel[key]['materiel']} placeholder={"Matériel " + (index+1)} className="form-control inputFile materielInput" onChange={(e) => {listMateriel(e.target.name, e.target.value, 'materiel')}} /></label><label className="modal-input-group">Légende<input type="text" value={csvMateriel[key]['legende']} name={key} placeholder={"Légende " + (index+1)} className="form-control inputFile materielInput" onChange={(e) => {listMateriel(e.target.name, e.target.value, 'legende')}} /></label><button type="button" aria-label="Supprimer le matériel" title="Supprimer" className="btn btn-danger btn-in-modal" name={key} onClick={(e) => {nbMaterielInc(nbMateriel,-1, e.target.name)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  ));

  Object.keys(csvVariable).map((key, index) => (
    inputVariable.push(<div key={"variable"+index} className="modal-edit-row"><label className="modal-input-group"><input type="text" name={key} value={csvVariable[key]} placeholder={"Variable " + (index+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" name={key} onClick={(e) => {nbVariableInc(nbVariable,-1, e.target.name)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  ));

  Object.keys(croquisSected).map((key, index) => (
    inputCroquis.push(<div key={"croquis"+index} className="modal-edit-row"><img src={croquisSected[key] !== undefined ? croquisSected[key]['croquis'] !== "" ? croquisSected[key]['croquis'] : "https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg" : "https://data.pixiz.com/output/user/frame/preview/api/big/5/6/1/0/2700165_4275d.jpg"} className="materielInput imageMateriel" alt="croquis" /><label className="modal-input-group">Lien du croquis<input type="text" name={key} placeholder={"Croquis"} value={croquisSected[key] !== undefined ? croquisSected[key]['croquis'] : '' || ''} className="form-control inputFile materielInput" onChange={(e) => {changeCroquis(e.target.name, e.target.value, 'croquis')}} /></label><label className="modal-input-group">Légende<input type="text" name={key} placeholder={"Légende"} value={croquisSected[key] !== undefined ? croquisSected[key]['legende'] : '' || ''} className="form-control inputFile materielInput" onChange={(e) => {changeCroquis(e.target.name, e.target.value, 'legende')}} /></label><button type="button" aria-label="Supprimer le croquis" title="Supprimer" className="btn btn-danger btn-in-modal" name={key} onClick={(e) => {nbCroquisInc(nbCroquis,-1, e.target.name)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  ));

  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog className={showModal3 === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Modification activité</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre de l’activité</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" defaultValue={tmpTitreActivite} onChange={(e) => {tmpTitreActivite = e.target.value}} placeholder="Titre activité" ref={titreActiviteValue => {
              tmpTitreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field"><span className="modal-label-text">Objectif</span><textarea id={modalKey + 'objectif'} key={modalKey + 'objectif'} type="text" className="form-control textArea1" defaultValue={tmpObjectif} onChange={(e) => {tmpObjectif = e.target.value}} placeholder="Objectif" ref={objectifValue => {
              tmpObjectif = objectifValue
            }}/></label>
            <label className="modal-field-label">Description de l’activité</label>
            <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                value={content}
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               //onEditorChange={(e) => { contentValue = e }}
             />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => { nbVariableInc(nbVariable,1)} }>Ajouter une variable</button>
            </div>
            <div className="modal-section">
              <div className="modal-section-label">Croquis</div>
              <button className="btn btn-success btn-in-modal" onClick={(e) => { nbCroquisInc(nbCroquis,1)} }>Ajouter un croquis</button>
              { inputCroquis }
            </div>
            <div className="modal-section">
              <div className="modal-section-label">Matériel</div>{inputMateriel}
            </div>
            <button className="btn btn-success btn-in-modal" onClick={(e) => { nbMaterielInc(nbMateriel,1)} }>Ajouter un matériel</button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { modifSeance(modifId,tmpTitreActivite.value === undefined ? tmpTitreActivite : tmpTitreActivite.value,tmpObjectif.value === undefined ? tmpObjectif : tmpObjectif.value, content)} }>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShow3(showModal3)} }>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

const ModifSeance2 = ({modalKey,initialValue,content,handleEditorChange,modifId,titre_activite,csvVariable,boolShow2Echauffement,showModalEchauffement2,nbVariable,listVariable,nbVariableInc,modifSeance2,checkonChange,onDrop,onDrop2}) => {
  let inputVariable = []

  let tmpTitreActivite = titre_activite

  Object.keys(csvVariable).map((key, index) => (
    inputVariable.push(<div key={"variable"+index} className="modal-edit-row"><label className="modal-input-group"><input type="text" name={key} value={csvVariable[key]} placeholder={"Variable " + (index+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" name={key} onClick={(e) => {nbVariableInc(nbVariable,-1, e.target.name)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  ));


  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog className={showModalEchauffement2 === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Modification échauffement</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre de l’échauffement</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" defaultValue={tmpTitreActivite} onChange={(e) => {tmpTitreActivite = e.target.value}} placeholder="Titre activité" ref={titreActiviteValue => {
              tmpTitreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field-label">Description de l’échauffement</label>
            <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                value={content}
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               //onEditorChange={(e) => { contentValue = e }}
             />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => { nbVariableInc(nbVariable,1)} }>Ajouter une variable</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { modifSeance2(modifId,tmpTitreActivite.value === undefined ? tmpTitreActivite : tmpTitreActivite.value, content)} }>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShow2Echauffement(showModalEchauffement2)} }>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

const ModifSeance3 = ({modalKey,initialValue,content,handleEditorChange,modifId,titre_activite,csvVariable,boolShow2CoinMaternelles,showModalCoinMaternelles2,nbVariable,listVariable,nbVariableInc,modifSeance3,checkonChange,onDrop,onDrop2}) => {
  let inputVariable = []

  let tmpTitreActivite = titre_activite

  Object.keys(csvVariable).map((key, index) => (
    inputVariable.push(<div key={"variable"+index} className="modal-edit-row"><label className="modal-input-group">Variable {index + 1}<input type="text" name={key} value={csvVariable[key]} placeholder={"Variable " + (index+1)} className="form-control inputFile" onChange={(e) => {listVariable(e.target.name, e.target.value)}} /></label><button type="button" aria-label="Supprimer la variable" title="Supprimer" className="btn btn-danger btn-in-modal" name={key} onClick={(e) => {nbVariableInc(nbVariable,-1, e.target.name)}}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></button></div>)
  ));


  return (
    <div className="static-modal" key={modalKey}>
      <Modal.Dialog className={showModalCoinMaternelles2 === false ? 'hide' : 'show specialPopUp'}>
        <Modal.Header>
          <Modal.Title>Modification coin</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="col-md-12 form-container">
            <label className="modal-field"><span className="modal-label-text">Titre du coin</span><input id={modalKey + 'titre'} key={modalKey + 'titre'} type="text" className="form-control" defaultValue={tmpTitreActivite} onChange={(e) => {tmpTitreActivite = e.target.value}} placeholder="Titre activité" ref={titreActiviteValue => {
              tmpTitreActivite = titreActiviteValue
            }}/></label>
            <label className="modal-field-label">Description du coin</label>
            <Editor
                apiKey="umktbzktl189dztfwxfm6tfjx53ygerulcbzjubxsnsn3vv9"
                value={content}
                init={{
                  formats : {
                    underline : {inline : 'u', exact : true}
                  },
                  selector: 'textarea#full-featured-non-premium',
                  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
                  autosave_ask_before_unload: false,
                  add_unload_trigger: false,
                  menubar: 'file edit view insert format tools table help',
                  toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl | customInsertButton customInsertButton2 customInsertButton3 customInsertButton4 customInsertButton5 customInsertButton6',
                  toolbar_sticky: false,
                  autosave_interval: '30s',
                  autosave_prefix: '{path}{query}-{id}-',
                  autosave_restore_when_empty: false,
                  autosave_retention: '2m',
                  image_advtab: true,
                  link_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_list: [
                    { title: 'My page 1', value: 'http://www.tinymce.com' },
                    { title: 'My page 2', value: 'http://www.moxiecode.com' }
                  ],
                  image_class_list: [
                    { title: 'None', value: '' },
                    { title: 'Some class', value: 'class-name' }
                  ],
                  importcss_append: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('customInsertButton', {
                      text: 'ℹ️',
                      onAction: function (_) {
                        editor.insertContent('<button title="CHANGE CE TEXTE">ℹ️</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton2', {
                      text: '⚽',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_materiel">⚽</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton3', {
                      text: '💡',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_defi">💡</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton4', {
                      text: '📈',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_up">📈</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton5', {
                      text: '🏆',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_win">🏆</button>');
                      }
                    });

                    editor.ui.registry.addButton('customInsertButton6', {
                      text: '💬',
                      onAction: function (_) {
                        editor.insertContent('<button title="id_speach">💬</button>');
                      }
                    });
                  },
                  file_picker_callback: function (callback, value, meta) {
                    /* Provide file and text for the link dialog */
                    if (meta.filetype === 'file') {
                      callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
                    }

                    /* Provide image and alt text for the image dialog */
                    if (meta.filetype === 'image') {
                      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
                    }

                    /* Provide alternative source and posted for the media dialog */
                    if (meta.filetype === 'media') {
                      callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
                    }
                  },
                  height: 600,
                  image_caption: true,
                  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                  noneditable_noneditable_class: 'mceNonEditable',
                  toolbar_mode: 'sliding',
                  contextmenu: 'link image table'
               }}
               onEditorChange={(e) => {handleEditorChange(e)}}
               //onEditorChange={(e) => { contentValue = e }}
             />
            <div className="modal-section">
              <div className="modal-section-label">Variables</div>{inputVariable}
              <button className="btn btn-success btn-in-modal" onClick={(e) => { nbVariableInc(nbVariable,1)} }>Ajouter une variable</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-success" onClick={(e) => { modifSeance3(modifId,tmpTitreActivite.value === undefined ? tmpTitreActivite : tmpTitreActivite.value, content)} }>valider</Button>
          <Button className="btn btn-danger" onClick={(e) => { boolShow2CoinMaternelles(showModalCoinMaternelles2)} }>annuler</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};


const AllSeance = ({allSeance1,openActivityModal,requestDelete,boolShow3,copyCodeToClipboard}) => {
  let allRow = {}

  var statut = cookies.get("statut")

  if(allSeance1) {
    let countRow = (allSeance1.length - 1)
    allRow = allSeance1.map((id,counter) => {
      return (
        <div key={id.id} className="col-md-12 noMargin">
          <div className="col-md-12 card-style">
            <div className={counter % 2 === 0 ? "cardActivite" : "cardActivite2"} onClick={(e) => {e.stopPropagation(); openActivityModal('seance', id.id, counter + 1)}}>
              <div className="col-md-12 flexDiv">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Activité</span>
                    <span className="numBubble">{counter + 1}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{id.titre_activite}</p>
                  <p className="titleActivityBubble2">Objectif: <span className="whiteText">{id.objectif}</span></p>
                </div>
              </div>
              <div className={countRow === counter ? "div-button activiteCard" : "div-button activiteCard"}>
                <button onClick={(e) => {window.scroll(0,0); e.stopPropagation(); boolShow3(false,counter,id.id)}} className={ statut !== 'correcteur' ? "btn btn-success marginAuto" : "hide"}>modifier</button>
                <button onClick={(e) => {e.stopPropagation(); requestDelete('seance', id.id, id.titre_activite)}} className={ statut !== 'correcteur' ? "btn btn-danger marginAuto" : "hide" }>supprimer</button>
                <button onClick={(e) => {e.stopPropagation(); copyCodeToClipboard("https://eps.acces-editions.com/api/getDetailSeance?id=" + id.id)}} className={ "btn btn-primary marginAuto" }>lien</button>
              </div>
            </div>
          </div>
        </div>
      )
    });
  }

  return allRow;
};

const AllSeance2 = ({listeEchauffementActivite,openActivityModal,requestDelete,boolShow2Echauffement,copyCodeToClipboard}) => {
  let allRow = {}

  var statut = cookies.get("statut")

  if(listeEchauffementActivite) {
    let countRow = (listeEchauffementActivite.length - 1)
    allRow = listeEchauffementActivite.map((id,counter) => {
      return (
        <div key={id.id + "_echauffement"} className="col-md-12 noMargin">
          <div className="col-md-12 card-style">
            <div className={counter % 2 === 0 ? "cardActivite" : "cardActivite2"} onClick={(e) => {e.stopPropagation(); openActivityModal('echauffement', id.id, counter + 1)}}>
              <div className="col-md-12 flexDiv">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Echauffement</span>
                    <span className="numBubble">{counter + 1}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{id.titre_activite}</p>
                </div>
              </div>
              <div className={countRow === counter ? "div-button activiteCard" : "div-button activiteCard"}>
                <button onClick={(e) => {window.scroll(0,0); e.stopPropagation(); boolShow2Echauffement(false,counter,id.id)}} className={ statut !== 'correcteur' ? "btn btn-success marginAuto" : "hide"}>modifier</button>
                <button onClick={(e) => {e.stopPropagation(); requestDelete('echauffement', id.id, id.titre_activite)}} className={ statut !== 'correcteur' ? "btn btn-danger marginAuto" : "hide" }>supprimer</button>
                <button onClick={(e) => {e.stopPropagation(); copyCodeToClipboard("https://eps.acces-editions.com/api/getEchauffementActivite?id=" + id.id)}} className={ "btn btn-primary marginAuto" }>lien</button>
              </div>
            </div>
          </div>
        </div>
      )
    });
  }

  return allRow;
};

const AllSeance3 = ({listeCoinMaternellesActivite,openActivityModal,requestDelete,boolShow2CoinMaternelles,copyCodeToClipboard}) => {
  let allRow = {}

  var statut = cookies.get("statut")

  if(listeCoinMaternellesActivite) {
    let countRow = (listeCoinMaternellesActivite.length - 1)
    allRow = listeCoinMaternellesActivite.map((id,counter) => {
      return (
        <div key={id.id + "_coin_maternelles"} className="col-md-12 noMargin">
          <div className="col-md-12 card-style">
            <div className={counter % 2 === 0 ? "cardActivite" : "cardActivite2"} onClick={(e) => {e.stopPropagation(); openActivityModal('coin', id.id, counter + 1)}}>
              <div className="col-md-12 flexDiv">
                <div className="titleAtelier">
                  <p className="labelActivite">
                    <span className="titleBubble">Coin</span>
                    <span className="numBubble">{counter + 1}</span>
                  </p>
                </div>
                <div className="titleActivityBubble">
                  <p className="titleActivityBubble1">{id.titre_activite}</p>
                </div>
              </div>
              <div className={countRow === counter ? "div-button activiteCard" : "div-button activiteCard"}>
                <button onClick={(e) => {window.scroll(0,0); e.stopPropagation(); boolShow2CoinMaternelles(false,counter,id.id)}} className={ statut !== 'correcteur' ? "btn btn-success marginAuto" : "hide"}>modifier</button>
                <button onClick={(e) => {e.stopPropagation(); requestDelete('coin', id.id, id.titre_activite)}} className={ statut !== 'correcteur' ? "btn btn-danger marginAuto" : "hide" }>supprimer</button>
                <button onClick={(e) => {e.stopPropagation(); copyCodeToClipboard("https://eps.acces-editions.com/api/getCoinMaternellesActivite?id=" + id.id)}} className={ "btn btn-primary marginAuto" }>lien</button>
              </div>
            </div>
          </div>
        </div>
      )
    });
  }

  return allRow;
};

class DashboardClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showModal1: false,
      showModal2: false,
      showModal3: false,
      showModal4: false,
      showModalEchauffement: false,
      showModalEchauffement2: false,
      showModalCoinMaternelles: false,
      showModalCoinMaternelles2: false,
      showSeance: false,
      showEchauffement2: false,
      showCoinMaternelles2: false,
      showActivityModal: false,
      activityModalData: null,
      activityModalType: null,
      activityModalNumber: null,
      activityDeletion: null,
      showCroquis: false,
      showMateriel: false,
      checked1: true,
      checked2: false,
      allSeance1: [],
      allSeance2: [],
      idUpdateModal: null,
      idContenuModal: null,
      nbMateriel: 1,
      nbVariable: 0,
      nbCroquis: 1,
      csvMateriel: {},
      csvVariable: {},
      pictures: [],
      pictures2: [],
      selectedFile: [],
      objectif: "",
      nameAtelier: "",
      descriptif: "",
      organisation: {},
      organisationDelete: [],
      listeCycle: {},
      listeCompetence: {},
      listeSequence: {},
      listeCategorie: {},
      listeEchauffement: {},
      listeEchauffementActivite: [],
      listeCoinMaternelles: {},
      listeCoinMaternellesActivite: [],
      cycleSelected: 0,
      competenceSelected: 0,
      echauffementSelected: 0,
      coinMaternellesSelected: 0,
      selectedEchauffement: null,
      selectedCoinMaternelles: null,
      sequenceSelected: 0,
      categorieSelected: 0,
      activiteSelected: "",
      selectedSeance: null,
      titre: "",
      titre_activite: "",
      modifId: null,
      identifiant: "",
      content: '',
      croquisSected: {},
      initialValue: 'Nouveau',
      buttonCoinMaternellesSelected: false,
      buttonEchauffementSelected: false,
      loadingCycle: true,
      loadingCompetence: false,
      loadingSequence: false,
      loadingCategorie: false,
      loadingEchauffement: false,
      loadingCoinMaternelles: false,
      key: Math.random(),
      key2: Math.random(),
      key3: Math.random(),
      key4: Math.random(),
      key5: Math.random(),
      key6: Math.random()
    }
    this.onDrop = this.onDrop.bind(this);
    this.onDrop2 = this.onDrop2.bind(this);
  }

  handleEditorChange(content) {
    this.setState({content:content.trim()})
  }

  onDrop(picture) {
    this.setState({
        pictures: picture,
    });
  }

  onDrop2(picture) {
    this.setState({
        pictures2: picture,
    });
  }

  boolShow(value) {
    this.setState({ 
      showModal: !value,
      nbVariable: 0,
      nbMateriel: 0,
      nbCroquis: 0,
      csvMateriel: {},
      csvVariable: {},
      organisation: {},
      key: Math.random()
    })
  }

  boolShowEchauffement(value) {
    this.setState({ 
      showModalEchauffement: !value,
      nbVariable: 0,
      nbMateriel: 1,
      nbCroquis: 1,
      csvMateriel: {},
      csvVariable: {},
      organisation: {},
      key: Math.random(),
      key2: Math.random(),
      key3: Math.random(),
      key4: Math.random()
    })
  }

  boolShowCoinMaternelles(value) {
    this.setState({ 
      showModalCoinMaternelles: !value,
      nbVariable: 0,
      nbMateriel: 1,
      nbCroquis: 1,
      csvMateriel: {},
      csvVariable: {},
      organisation: {},
      key: Math.random(),
      key2: Math.random(),
      key3: Math.random(),
      key4: Math.random()
    })
  }

  boolShow1(value,id) {
    this.setState({ 
      showModal1: !value,
      idUpdateModal: id
    })
  }

  boolShow2(value,id) {
      this.setState({ 
        showModal2: !value,
        idContenuModal: id,
        nbMateriel: 1,
      })
  }

  copyCodeToClipboard(lien) {
    window.prompt("Lien symbolique", lien);
  }

  async boolShow3(value,id,id_seance) {
    if(value === false) {
      await this.loadDetailSeance(id_seance)

      let croquis = JSON.parse(this.state.detailSeance[0].croquis)
      let variable = JSON.parse(this.state.detailSeance[0].variable)
      let materiel = JSON.parse(this.state.detailSeance[0].materiel)
      let descriptif = this.state.detailSeance[0].descriptif

      let titre = this.state.detailSeance[0].titre
      let titre_activite = this.state.detailSeance[0].titre_activite
      let objectif = this.state.detailSeance[0].objectif

      let nbMateriel = Object.keys(materiel).length
      let nbVariable = Object.keys(variable).length
      let nbCroquis = Object.keys(croquis).length

      this.setState({
        modifId: id_seance,
        showModal3: !value,
        idContenuModal: id,
        csvMateriel: materiel,
        csvVariable: variable,
        nbMateriel: nbMateriel,
        nbVariable: nbVariable,
        nbCroquis: nbCroquis,
        croquisSected: croquis,
        titre: titre,
        titre_activite: titre_activite,
        objectif: objectif,
        content: descriptif,
        key: Math.random(),
        key2: Math.random(),
        key3: Math.random(),
        key4: Math.random()
      })
    } else {
      this.setState({ 
        showModal3: !value

      })
    }
  }

  async boolShow2Echauffement(value,id,id_seance) {
    if(value === false) {
      await this.loadDetailSeanceEchauffement(id_seance)

      let variable = JSON.parse(this.state.detailSeanceEchauffement[0].variable)
      let descriptif = this.state.detailSeanceEchauffement[0].descriptif

      let titre_activite = this.state.detailSeanceEchauffement[0].titre_activite

      let nbVariable = Object.keys(variable).length

      this.setState({
        modifId: id_seance,
        showModalEchauffement2: !value,
        idContenuModal: id,
        nbVariable: nbVariable,
        csvVariable: variable,
        titre_activite: titre_activite,
        content: descriptif,
        key: Math.random(),
        key2: Math.random(),
        key3: Math.random(),
        key4: Math.random()
      })
    } else {
      this.setState({ 
        showModalEchauffement2: !value
      })
    }
  }

  async boolShow2CoinMaternelles(value,id,id_seance) {
    if(value === false) {
      await this.loadDetailSeanceCoinMaternelles(id_seance)

      let variable = JSON.parse(this.state.detailSeanceCoinMaternelles[0].variable)
      let descriptif = this.state.detailSeanceCoinMaternelles[0].descriptif

      let titre_activite = this.state.detailSeanceCoinMaternelles[0].titre_activite

      let nbVariable = Object.keys(variable).length

      this.setState({
        modifId: id_seance,
        showModalCoinMaternelles2: !value,
        idContenuModal: id,
        nbVariable: nbVariable,
        csvVariable: variable,
        titre_activite: titre_activite,
        content: descriptif,
        key: Math.random(),
        key2: Math.random(),
        key3: Math.random(),
        key4: Math.random()
      })
    } else {
      this.setState({ 
        showModalCoinMaternelles2: !value
      })
    }
  }

  async boolShow4(value,id,id_seance) {
    await this.loadDetailSeance(id_seance)
    this.setState({ 
      showModal4: !value,
      idContenuModal: id
    })
  }

  async openActivityModal(type, id_seance, counter) {
    const loaders = {
      seance: this.loadDetailSeance.bind(this),
      echauffement: this.loadDetailSeanceEchauffement.bind(this),
      coin: this.loadDetailSeanceCoinMaternelles.bind(this)
    };
    const details = loaders[type] ? await loaders[type](id_seance) : null;
    const detail = Array.isArray(details) ? details[0] : details;
    if (!detail) return;

    this.setState({
      showActivityModal: true,
      activityModalData: detail,
      activityModalType: type,
      activityModalNumber: counter,
      showSeance: false,
      showEchauffement2: false,
      showCoinMaternelles2: false,
      showCroquis: false,
      showMateriel: false
    });
  }

  closeActivityModal() {
    this.setState({
      showActivityModal: false,
      activityModalData: null,
      activityModalType: null,
      activityModalNumber: null
    });
  }

  requestActivityDeletion(kind, id, name) {
    this.setState({ activityDeletion: { kind, id, name } });
  }

  cancelActivityDeletion() {
    this.setState({ activityDeletion: null });
  }

  confirmActivityDeletion() {
    const deletion = this.state.activityDeletion;
    if (!deletion) return;
    this.setState({ activityDeletion: null });
    if (deletion.kind === 'echauffement') this.deleteEchauffement(deletion.id);
    else if (deletion.kind === 'coin') this.deleteCoinMaternelles(deletion.id);
    else this.deleteSeance(deletion.id);
  }

  async displaySeance(value,id_seance,counter) {
    await this.loadDetailSeance(id_seance)
    if(id_seance !== this.state.selectedSeance) {
      this.setState({
        selectedSeance: id_seance,
        showSeance: true,
        showCroquis: false,
        showMateriel: false,
        numBubble: counter
      })
    } else {
      this.setState({
        selectedSeance: null,
        showSeance: false,
        showCroquis: false,
        showMateriel: false,
        numBubble: counter
      })
    }
  }

  async displayEchauffement(value,id_seance,counter) {
    await this.loadDetailSeanceEchauffement(id_seance)
    if(id_seance !== this.state.selectedEchauffement) {
      this.setState({
        selectedEchauffement: id_seance,
        showEchauffement2: true,
        numBubble: counter
      })
    } else {
      this.setState({
        selectedEchauffement: null,
        showEchauffement2: false,
        numBubble: counter
      })
    }
  }

  async displayCoinMaternelles(value,id_seance,counter) {
    await this.loadDetailSeanceCoinMaternelles(id_seance)
    if(id_seance !== this.state.selectedCoinMaternelles) {
      this.setState({
        selectedCoinMaternelles: id_seance,
        showCoinMaternelles2: true,
        numBubble: counter
      })
    } else {
      this.setState({
        selectedCoinMaternelles: null,
        showCoinMaternelles2: false,
        numBubble: counter
      })
    }
  }

  displaySeance2() {
    this.setState({
      showSeance: true,
      showCroquis: false,
      showMateriel: false
    })
  }

  displayCroquis() {
    this.setState({
      showSeance: false,
      showCroquis: true,
      showMateriel: false
    })
  }
  
  displayMateriel() {
    this.setState({
      showSeance: false,
      showCroquis: false,
      showMateriel: true
    })
  }

  changeEchauffement(id) {
    if(id !== this.state.echauffementSelected) {
      this.setState({
        cycleSelected: null,
        competenceSelected: 0,
        echauffementSelected: id,
        coinMaternellesSelected: 0,
        sequenceSelected: 0,
        categorieSelected: 0,
        allSeance1:[],
        allSeance2: [],
        listeEchauffementActivite: [],
        listeCoinMaternelles: {},
        listeCoinMaternellesActivite: [],
        listeCompetence: {},
        listeSequence: {},
        listeCategorie: {},
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      }, () => {
        this.loadEchauffementActivite()
      })
    }
  }

  changeCoinMaternelles(id) {
    if(id !== this.state.coinMaternellesSelected) {
      this.setState({
        cycleSelected: null,
        competenceSelected: 0,
        echauffementSelected: 0,
        coinMaternellesSelected: id,
        sequenceSelected: 0,
        categorieSelected: 0,
        allSeance1:[],
        allSeance2: [],
        listeEchauffement: {},
        listeEchauffementActivite: [],
        listeCoinMaternellesActivite: [],
        listeCompetence: {},
        listeSequence: {},
        listeCategorie: {},
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      }, () => {
        this.loadCoinMaternellesActivite()
      })
    }
  }

  changeCycle(id) {
    if(id !== this.state.cycleSelected) {
      this.setState({
        cycleSelected: id,
        buttonCoinMaternellesSelected: false,
        buttonEchauffementSelected: false,
        loadingCompetence: true,
        loadingSequence: false,
        loadingCategorie: false,
        loadingEchauffement: false,
        loadingCoinMaternelles: false,
        competenceSelected: 0,
        echauffementSelected: 0,
        coinMaternellesSelected: 0,
        sequenceSelected: 0,
        categorieSelected: 0,
        activiteSelected: "",
        allSeance1:[],
        allSeance2: [],
        listeEchauffement: {},
        listeEchauffementActivite: [],
        listeCoinMaternelles: {},
        listeCoinMaternellesActivite: [],
        listeCompetence: {},
        listeSequence: {},
        listeCategorie: {},
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      }, () => {
        this.loadCompetence()
      })
    }
  }

  changeCompetence(id) {
    if(id !== this.state.competenceSelected) {
      this.setState({
        competenceSelected: id,
        loadingSequence: true,
        loadingCategorie: false,
        sequenceSelected: 0,
        echauffementSelected: 0,
        coinMaternellesSelected: 0,
        categorieSelected: 0,
        allSeance1:[],
        allSeance2: [],
        listeEchauffement: {},
        listeEchauffementActivite: [],
        listeCoinMaternelles: {},
        listeCoinMaternellesActivite: [],
        listeSequence: {},
        listeCategorie: {},
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      }, () => {
        this.loadSequence()
      })
    }
  }

  changeSequence(id,name) {
    if(id !== this.state.sequenceSelected) {
      this.setState({
        sequenceSelected: id,
        loadingCategorie: true,
        allSeance1:[],
        allSeance2: [],
        listeEchauffement: {},
        listeEchauffementActivite: [],
        listeCoinMaternelles: {},
        listeCoinMaternellesActivite: [],
        listeCategorie: {},
        activiteSelected: name,
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      },() => {
        this.loadCategorie()
      })
    }
  }

  changeCategorie(id) {
    if(id !== this.state.categorieSelected) {
      this.setState({
        categorieSelected: id,
        allSeance1:[],
        allSeance2: [],
        selectedSeance: null,
        showSeance: false,
        showEchauffement2: false,
        showCoinMaternelles2: false,
        showCroquis: false,
        showMateriel: false
      },() => {
        this.loadSeance()
      })
    }
  }

  nbMaterielInc(nbMateriel, inc, current) {
    nbMateriel += inc

    if(nbMateriel >= 1) {
      if(inc < 0) {
        let csvMateriel = this.state.csvMateriel

        if(current !== undefined) {
          delete csvMateriel[current]
        } else {
          delete csvMateriel[nbMateriel]
        }

        this.setState({
          csvMateriel: csvMateriel,
          nbMateriel: nbMateriel
        })
      } else {
        let csvMateriel = this.state.csvMateriel

        var key = parseInt(Object.keys(csvMateriel)[Object.keys(csvMateriel).length-1], 10) + 1

        if(key >= 0) {
          csvMateriel[key] = {'materiel': '', 'legende': ''}
        } else {
          csvMateriel[nbMateriel] = {'materiel': '', 'legende': ''}
        }

        this.setState({
          csvMateriel: csvMateriel,
          nbMateriel: nbMateriel
        })
      }
    } else {
      this.setState({
        csvMateriel: {},
        nbMateriel: 0
      })
    }
  }

  nbCroquisInc(nbCroquis, inc, current) {
    nbCroquis += inc

    if(nbCroquis >= 1) {
      if(inc < 0) {
        let croquisSected = this.state.croquisSected

        if(current !== undefined) {
          delete croquisSected[current]
        } else {
          delete croquisSected[nbCroquis]
        }
        this.setState({
          croquisSected: croquisSected,
          nbCroquis: nbCroquis
        })
      } else {
        let croquisSected = this.state.croquisSected

        var key = 0
        if(Object.keys(croquisSected).length > 0) {
          key = parseInt(Object.keys(croquisSected)[Object.keys(croquisSected).length-1], 10) + 1
        }

        if(key >= 0) {
          croquisSected[key] = {'croquis': '', 'legende': ''}
        } else {
          croquisSected[nbCroquis] = {'croquis': '', 'legende': ''}
        }

        this.setState({
          croquisSected: croquisSected,
          nbCroquis: nbCroquis
        })
      }
    } else {
      this.setState({
        croquisSected: {},
        nbCroquis: 0
      })
    }
  }

  nbVariableInc(nbVariable, inc, current) {
    nbVariable += inc

    if(nbVariable >= 1) {
      if(inc < 0) {
        let csvVariable = this.state.csvVariable

        if(current !== undefined) {
          delete csvVariable[current]
        } else {
          delete csvVariable[nbVariable]
        }
        this.setState({
          csvVariable: csvVariable,
          nbVariable: nbVariable
        })
      } else {
        let csvVariable = this.state.csvVariable

        var key = 0
        if(Object.keys(csvVariable).length > 0) {
          key = parseInt(Object.keys(csvVariable)[Object.keys(csvVariable).length-1], 10) + 1
        }

        csvVariable[key] = ''

        this.setState({
          csvVariable: csvVariable,
          nbVariable: nbVariable
        })
      }
    } else {
      this.setState({
        csvVariable: {},
        nbVariable: 0
      })
    }
  }

  updateInputSeance(id,value,index) {
    let allSeance2 = this.state.allSeance2
    allSeance2[index][id] = value
    this.setState({
      allSeance2: allSeance2
    })
  }

  listMateriel(id, value, key) {
    var csvMateriel = this.state.csvMateriel
    if (csvMateriel[id] === undefined) {
      csvMateriel[id] = {}
    }
    csvMateriel[id][key] = value
    this.setState({
      csvMateriel: csvMateriel
    })
  }

  changeCroquis(id, value, key) {
    var croquisSected = this.state.croquisSected
    if (croquisSected[id] === undefined) {
      croquisSected[id] = {}
    }

    if(value === "") {
      croquisSected = {}
    } else {
      croquisSected[id][key] = value
    }
    this.setState({
      croquisSected: croquisSected
    })
  }

  listVariable(id, value) {
    var csvVariable = this.state.csvVariable
    csvVariable[id] = value
    this.setState({
      csvVariable: csvVariable
    })
  }

  componentDidMount() {
    this.loadCycle();
  } 

  loadCycle() {
    const loadingStartedAt = Date.now();
    this.setState({ loadingCycle: true });
    axios.get('/api/getCycle') 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeCycle: res.data.listeCycle,
            loadingCycle: false,
            buttonCoinMaternellesSelected: false,
            buttonEchauffementSelected: false,
          })
        } else {
          this.setState({ loadingCycle: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingCycle: false })));
  }

  loadCompetence() {
    const loadingStartedAt = Date.now();

    this.setState({ loadingCompetence: true });
    axios.get('/api/getCompetence', { params: { id_cycle: this.state.cycleSelected } }) 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeCompetence: res.data.listeCompetence ? res.data.listeCompetence : {},
            loadingCompetence: false
          })
        } else {
          this.setState({ loadingCompetence: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingCompetence: false })));
  }

  loadEchauffement() {
    const loadingStartedAt = Date.now();

    // Clear the cycle view immediately. Waiting for the API response leaves
    // the previous cycle cards visible during the resource transition.
    this.setState({
      cycleSelected: null,
      competenceSelected: 0,
      sequenceSelected: 0,
      categorieSelected: 0,
      activiteSelected: "",
      buttonEchauffementSelected: true,
      buttonCoinMaternellesSelected: false,
      loadingEchauffement: true,
      loadingCoinMaternelles: false,
      loadingCompetence: false,
      loadingSequence: false,
      loadingCategorie: false,
      listeCompetence: {},
      listeSequence: {},
      listeCategorie: {},
      listeCoinMaternelles: {},
      listeCoinMaternellesActivite: [],
      allSeance1: [],
      allSeance2: [],
      selectedSeance: null,
      showSeance: false,
      showEchauffement2: false,
      showCoinMaternelles2: false
    });
    axios.get('/api/getEchauffement') 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeEchauffement: res.data.listeEchauffement,
            listeCoinMaternelles: {},
            listeCoinMaternellesActivite: [],
            coinMaternellesSelected: 0,
            buttonCoinMaternellesSelected: false,
            buttonEchauffementSelected: true,
            loadingCompetence: false,
            loadingSequence: false,
            loadingCategorie: false,
            loadingEchauffement: false,
          })
        } else {
          this.setState({ loadingEchauffement: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingEchauffement: false })));
  }

  loadEchauffementActivite() {
    axios.get('/api/getEchauffementActivite', { params: { id_echauffement: this.state.echauffementSelected } }) 
    .then((res) => {
      if(res.data) {
        this.setState({
          listeEchauffementActivite: res.data.listeEchauffementActivite
        })
      }
    });
  }

  loadCoinMaternelles() {
    const loadingStartedAt = Date.now();

    // Clear the cycle view immediately. Waiting for the API response leaves
    // the previous cycle cards visible during the resource transition.
    this.setState({
      cycleSelected: null,
      competenceSelected: 0,
      sequenceSelected: 0,
      categorieSelected: 0,
      activiteSelected: "",
      buttonCoinMaternellesSelected: true,
      buttonEchauffementSelected: false,
      loadingCoinMaternelles: true,
      loadingEchauffement: false,
      loadingCompetence: false,
      loadingSequence: false,
      loadingCategorie: false,
      listeCompetence: {},
      listeSequence: {},
      listeCategorie: {},
      listeEchauffement: {},
      listeEchauffementActivite: [],
      allSeance1: [],
      allSeance2: [],
      selectedSeance: null,
      showSeance: false,
      showEchauffement2: false,
      showCoinMaternelles2: false
    });
    axios.get('/api/getCoinMaternelles') 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeCoinMaternelles: res.data.listeCoinMaternelles,
            listeEchauffement: {},
            listeEchauffementActivite: [],
            echauffementSelected: 0,
            buttonCoinMaternellesSelected: true,
            buttonEchauffementSelected: false,
            loadingCompetence: false,
            loadingSequence: false,
            loadingCategorie: false,
            loadingCoinMaternelles: false,
          })
        } else {
          this.setState({ loadingCoinMaternelles: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingCoinMaternelles: false })));
  }

  loadCoinMaternellesActivite() {
    axios.get('/api/getCoinMaternellesActivite', { params: { id_coin_maternelles: this.state.coinMaternellesSelected } }) 
    .then((res) => {
      if(res.data) {
        this.setState({
          listeCoinMaternellesActivite: res.data.listeCoinMaternellesActivite
        })
      }
    });
  }

  loadSequence() {
    const loadingStartedAt = Date.now();

    this.setState({ loadingSequence: true });
    axios.get('/api/getSequence', { params: { id_competence: this.state.competenceSelected } }) 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeSequence: res.data.listeSequence,
            loadingSequence: false,
          })
        } else {
          this.setState({ loadingSequence: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingSequence: false })));
  }

  loadCategorie() {
    const loadingStartedAt = Date.now();

    this.setState({ loadingCategorie: true });
    axios.get('/api/getCategorie', { params: { id_sequence: this.state.sequenceSelected } }) 
    .then((res) => {
      finishSelectionLoading(loadingStartedAt, () => {
        if(res.data) {
          this.setState({
            listeCategorie: res.data.listeCategorie,
            categorieSelected: res.data.listeCategorie.length > 0 ? 0 : -1,
            loadingCategorie: false,
          }, () => {
            if(this.state.categorieSelected === -1) {
              this.loadSeance()
            }
          })
        } else {
          this.setState({ loadingCategorie: false });
        }
      });
    }).catch(() => finishSelectionLoading(loadingStartedAt, () => this.setState({ loadingCategorie: false })));
  }

  loadSeance() {
    axios.get('/api/getSeance', { params: { id_categorie: this.state.categorieSelected, id_sequence: this.state.sequenceSelected } }) 
    .then((res) => {
      if(res.data) {
        this.setState({
          allSeance1: res.data.allSeance,
          allSeance2: res.data.allSeance1,
          showSeance: false,
          showCroquis: false,
          showMateriel: false
        })
      }
    });
  }

  async loadDetailSeance(id) {
    const res = await axios.get('/api/getDetailSeance', { params: { id: id } });
    if(res.data) this.setState({ detailSeance: res.data.detailSeance });
    return res.data && res.data.detailSeance;
  }

  async loadDetailSeanceEchauffement(id) {
    const res = await axios.get('/api/getDetailSeanceEchauffement', { params: { id: id } });
    if(res.data) this.setState({ detailSeanceEchauffement: res.data.detailSeance });
    return res.data && res.data.detailSeance;
  }

  async loadDetailSeanceCoinMaternelles(id) {
    const res = await axios.get('/api/getDetailSeanceCoinMaternelles', { params: { id: id } });
    if(res.data) this.setState({ detailSeanceCoinMaternelles: res.data.detailSeance });
    return res.data && res.data.detailSeance;
  }

  checkonChange(value,position) {
    position === 1 ? this.setState({checked1:!value, checked2: false}) : this.setState({checked1: false, checked2: !value}) 
  }

  createSeance(titreActivite,objectif,descriptif) {

    const formData = new FormData()

    formData.append('titreActivite', titreActivite)
    formData.append('objectif', objectif)
    formData.append('descriptif', descriptif)
    formData.append('materiel', JSON.stringify(this.state.csvMateriel))
    formData.append('variable', JSON.stringify(this.state.csvVariable))
    formData.append('croquis', JSON.stringify(this.state.croquisSected))
    formData.append('id_categorie', this.state.categorieSelected)
    formData.append('id_sequence', this.state.sequenceSelected)

    axios.post('/api/createSeance', formData) 
    .then((res) => {
      this.boolShow(true)
      this.loadSeance()
    });
  }

  createEchauffement(titreActivite,descriptif) {

    const formData = new FormData()

    formData.append('id_echauffement', this.state.echauffementSelected)
    formData.append('titreActivite', titreActivite)
    formData.append('descriptif', descriptif)
    formData.append('variable', JSON.stringify(this.state.csvVariable))

    axios.post('/api/createEchauffement', formData) 
    .then((res) => {
      this.boolShowEchauffement(true)
      this.loadEchauffementActivite()
    });
  }

  createCoinMaternelles(titreActivite,descriptif) {

    const formData = new FormData()

    formData.append('id_coin_maternelles', this.state.coinMaternellesSelected)
    formData.append('titreActivite', titreActivite)
    formData.append('descriptif', descriptif)
    formData.append('variable', JSON.stringify(this.state.csvVariable))

    axios.post('/api/createCoinMaternelles', formData) 
    .then((res) => {
      this.boolShowCoinMaternelles(true)
      this.loadCoinMaternellesActivite()
    });
  }

  deleteSeance(id) {
    const formData = new FormData()

    formData.append('id', id)
    axios.post('/api/deleteSeance', formData) 
    .then((res) => {
      this.loadSeance()
    });
  }

  deleteEchauffement(id) {
    const formData = new FormData()

    formData.append('id', id)
    axios.post('/api/deleteEchauffement', formData) 
    .then((res) => {
      this.loadEchauffementActivite()
    });
  }

  deleteCoinMaternelles(id) {
    const formData = new FormData()

    formData.append('id', id)
    axios.post('/api/deleteCoinMaternelles', formData) 
    .then((res) => {
      this.loadCoinMaternellesActivite()
    });
  }

  modifSeance(modifId,titre_activite,objectif,content) {
    const formData = new FormData()

    formData.append('id', modifId)
    formData.append('titre_activite', titre_activite)
    formData.append('objectif', objectif)
    formData.append('descriptif', content)
    formData.append('materiel', JSON.stringify(this.state.csvMateriel))
    formData.append('variable', JSON.stringify(this.state.csvVariable))
    formData.append('croquis', JSON.stringify(this.state.croquisSected))

    axios.post('/api/modifSeance', formData)
    .then((res) => {
      this.boolShow3(true)
      this.loadSeance()
    })
    .catch(err => {
      console.log(err)
    });
  }

  modifSeance2(modifId,titre_activite,content) {
    const formData = new FormData()

    formData.append('id', modifId)
    formData.append('titre_activite', titre_activite)
    formData.append('descriptif', content)
    formData.append('variable', JSON.stringify(this.state.csvVariable))

    axios.post('/api/modifSeance2', formData)
    .then((res) => {
      this.boolShow2Echauffement(true)
      this.loadEchauffementActivite()
    })
    .catch(err => {
      console.log(err)
    });
  }

  modifSeance3(modifId,titre_activite,content) {
    const formData = new FormData()

    formData.append('id', modifId)
    formData.append('titre_activite', titre_activite)
    formData.append('descriptif', content)
    formData.append('variable', JSON.stringify(this.state.csvVariable))

    axios.post('/api/modifSeance3', formData)
    .then((res) => {
      this.boolShow2CoinMaternelles(true)
      this.loadCoinMaternellesActivite()
    })
    .catch(err => {
      console.log(err)
    });
  }

  deconnexion() {
    cookies.remove('authenticated');
    history.go('/');
  }

  render() {

    let visible = this.state.allSeance1.length > 0 ? true : false
    let visible2 = this.state.listeEchauffementActivite.length > 0 ? true : false
    let visible3 = this.state.listeCoinMaternellesActivite.length > 0 ? true : false
    const hasWorkspaceSelection = this.state.competenceSelected > 0 || this.state.echauffementSelected > 0 || this.state.coinMaternellesSelected > 0 || this.state.sequenceSelected > 0 || this.state.categorieSelected > 0

    return (
      <main className="eps-dashboard">
        <header className="eps-dashboard-header">
          <img src={Logo} className="eps-dashboard-logo" alt="Accès EPS" />
          <Deconnexion deconnexion={this.deconnexion.bind(this)}/>
        </header>

        <div className="eps-dashboard-content">
          <SelectCycle listeCycle={this.state.listeCycle} cycleSelected={this.state.cycleSelected} buttonEchauffementSelected={this.state.buttonEchauffementSelected} buttonCoinMaternellesSelected={this.state.buttonCoinMaternellesSelected} changeCycle={this.changeCycle.bind(this)} loadEchauffement={this.loadEchauffement.bind(this)} loadCoinMaternelles={this.loadCoinMaternelles.bind(this)} loading={this.state.loadingCycle} />
          <SelectCompetence listeCompetence={this.state.listeCompetence} competenceSelected={this.state.competenceSelected} changeCompetence={this.changeCompetence.bind(this)} loading={this.state.loadingCompetence} reserve={!this.state.buttonEchauffementSelected && !this.state.buttonCoinMaternellesSelected && !this.state.loadingEchauffement && !this.state.loadingCoinMaternelles} />
          <SelectEchauffement listeEchauffement={this.state.listeEchauffement} echauffementSelected={this.state.echauffementSelected} changeEchauffement={this.changeEchauffement.bind(this)} loading={this.state.loadingEchauffement}/>
          <SelectCoinMaternelles listeCoinMaternelles={this.state.listeCoinMaternelles} coinMaternellesSelected={this.state.coinMaternellesSelected} changeCoinMaternelles={this.changeCoinMaternelles.bind(this)} loading={this.state.loadingCoinMaternelles}/>
          <SelectSequence listeSequence={this.state.listeSequence} sequenceSelected={this.state.sequenceSelected} changeSequence={this.changeSequence.bind(this)} loading={this.state.loadingSequence} reserve={!this.state.buttonEchauffementSelected && !this.state.buttonCoinMaternellesSelected && !this.state.loadingEchauffement && !this.state.loadingCoinMaternelles} />
          <SelectCategorie listeCategorie={this.state.listeCategorie} categorieSelected={this.state.categorieSelected} changeCategorie={this.changeCategorie.bind(this)} showModal={this.state.showModal} boolShow={this.boolShow.bind(this)} loading={this.state.loadingCategorie} reserve={!this.state.buttonEchauffementSelected && !this.state.buttonCoinMaternellesSelected && !this.state.loadingEchauffement && !this.state.loadingCoinMaternelles}/>
          <NewSeanceModal key={'activity-' + this.state.key} modalKey={this.state.key} initialValue={this.state.initialValue} csvMateriel={this.state.csvMateriel} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} showModal={this.state.showModal} boolShow={this.boolShow.bind(this)} nbMateriel={this.state.nbMateriel} nbVariable={this.state.nbVariable} nbCroquis={this.state.nbCroquis} listMateriel={this.listMateriel.bind(this)} listVariable={this.listVariable.bind(this)} nbMaterielInc={this.nbMaterielInc.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} nbCroquisInc={this.nbCroquisInc.bind(this)} createSeance={this.createSeance.bind(this)} checkonChange={this.checkonChange.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} changeCroquis={this.changeCroquis.bind(this)} croquisSected={this.state.croquisSected} />
          <NewSeanceModal2 key={'warmup-' + this.state.key3} modalKey={this.state.key3} initialValue={this.state.initialValue} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} showModalEchauffement={this.state.showModalEchauffement} boolShowEchauffement={this.boolShowEchauffement.bind(this)} nbVariable={this.state.nbVariable} listVariable={this.listVariable.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} createEchauffement={this.createEchauffement.bind(this)} checkonChange={this.checkonChange.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} />
          <NewSeanceModal3 key={'kindergarten-' + this.state.key3} modalKey={this.state.key3} initialValue={this.state.initialValue} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} showModalCoinMaternelles={this.state.showModalCoinMaternelles} boolShowCoinMaternelles={this.boolShowCoinMaternelles.bind(this)} nbVariable={this.state.nbVariable} listVariable={this.listVariable.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} createCoinMaternelles={this.createCoinMaternelles.bind(this)} checkonChange={this.checkonChange.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} />
          
          <ModifSeance key={'edit-activity-' + this.state.key2} modalKey={this.state.key2} initialValue={this.state.initialValue} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} modifId={this.state.modifId} titre_activite={this.state.titre_activite} objectif={this.state.objectif} csvMateriel={this.state.csvMateriel} csvVariable={this.state.csvVariable} showModal3={this.state.showModal3} boolShow3={this.boolShow3.bind(this)} nbMateriel={this.state.nbMateriel} nbVariable={this.state.nbVariable} nbCroquis={this.state.nbCroquis} listMateriel={this.listMateriel.bind(this)} listVariable={this.listVariable.bind(this)} nbMaterielInc={this.nbMaterielInc.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} nbCroquisInc={this.nbCroquisInc.bind(this)} modifSeance={this.modifSeance.bind(this)} checkonChange={this.checkonChange.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} croquisSected={this.state.croquisSected} changeCroquis={this.changeCroquis.bind(this) } />
          <ModifSeance2 key={'edit-warmup-' + this.state.key4} modalKey={this.state.key4} initialValue={this.state.initialValue} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} modifId={this.state.modifId} titre_activite={this.state.titre_activite} showModalEchauffement2={this.state.showModalEchauffement2} boolShow2Echauffement={this.boolShow2Echauffement.bind(this)} csvVariable={this.state.csvVariable} nbVariable={this.state.nbVariable} listVariable={this.listVariable.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} createEchauffement={this.createEchauffement.bind(this)} checkonChange={this.checkonChange.bind(this)} modifSeance2={this.modifSeance2.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} />
          <ModifSeance3 key={'edit-kindergarten-' + this.state.key4} modalKey={this.state.key4} initialValue={this.state.initialValue} content={this.state.content} handleEditorChange={this.handleEditorChange.bind(this)} modifId={this.state.modifId} titre_activite={this.state.titre_activite} showModalCoinMaternelles2={this.state.showModalCoinMaternelles2} boolShow2CoinMaternelles={this.boolShow2CoinMaternelles.bind(this)} csvVariable={this.state.csvVariable} nbVariable={this.state.nbVariable} listVariable={this.listVariable.bind(this)} nbVariableInc={this.nbVariableInc.bind(this)} createCoinMaternelles={this.createCoinMaternelles.bind(this)} checkonChange={this.checkonChange.bind(this)} modifSeance3={this.modifSeance3.bind(this)} onDrop={this.onDrop} onDrop2={this.onDrop2} />
          <ActivityDetailModal show={this.state.showActivityModal} detail={this.state.activityModalData} type={this.state.activityModalType} numBubble={this.state.activityModalNumber} onHide={this.closeActivityModal.bind(this)} />
          <ActivityDeleteConfirmation deletion={this.state.activityDeletion} onCancel={this.cancelActivityDeletion.bind(this)} onConfirm={this.confirmActivityDeletion.bind(this)} />
          
          <section className="eps-workspace-panel">
            <div className="eps-workspace-heading">
              <div className="eps-workspace-title">
                <span className="eps-workspace-icon"><FontAwesomeIcon icon={faTableCellsLarge} aria-hidden="true" /></span>
                <div><h1>Espace de travail</h1><p>Sélectionnez un cycle et une ressource pour commencer.</p><AuthorLinks routeFile={this.state.activiteSelected.toString()} cycleSelected={this.state.cycleSelected} /></div>
              </div>
              <div className="eps-workspace-actions">
                <Dashboard showModal={this.state.showModal} boolShow={this.boolShow.bind(this)} categorieSelected={this.state.categorieSelected} />
                <Dashboard2 showModalEchauffement={this.state.showModalEchauffement} boolShowEchauffement={this.boolShowEchauffement.bind(this)} echauffementSelected={this.state.echauffementSelected} />
                <Dashboard3 showModalCoinMaternelles={this.state.showModalCoinMaternelles} boolShowCoinMaternelles={this.boolShowCoinMaternelles.bind(this)} coinMaternellesSelected={this.state.coinMaternellesSelected} />
              </div>
            </div>
            {hasWorkspaceSelection ? <div className={`col-md-12 noPadding2 bodyFlex${this.state.showSeance || this.state.showEchauffement2 || this.state.showCoinMaternelles2 ? ' has-detail' : ''}`}>
            <div className="col-md-4">
              <div className="row contentAtelier">
                {visible && <div className="col-md-12 noPadding2 eps-activity-list">
                  <AllSeance key="activities" allSeance1={this.state.allSeance1} openActivityModal={this.openActivityModal.bind(this)} requestDelete={this.requestActivityDeletion.bind(this)} boolShow3={this.boolShow3.bind(this)} copyCodeToClipboard={this.copyCodeToClipboard.bind(this)} />
                </div>}
                {visible2 && <div className="col-md-12 noPadding2 eps-activity-list">
                  <AllSeance2 key="warmups" listeEchauffementActivite={this.state.listeEchauffementActivite} openActivityModal={this.openActivityModal.bind(this)} requestDelete={this.requestActivityDeletion.bind(this)} boolShow2Echauffement={this.boolShow2Echauffement.bind(this)} copyCodeToClipboard={this.copyCodeToClipboard.bind(this)} />
                </div>}
                {visible3 && <div className="col-md-12 noPadding2 eps-activity-list">
                  <AllSeance3 key="kindergarten" listeCoinMaternellesActivite={this.state.listeCoinMaternellesActivite} openActivityModal={this.openActivityModal.bind(this)} requestDelete={this.requestActivityDeletion.bind(this)} boolShow2CoinMaternelles={this.boolShow2CoinMaternelles.bind(this)} copyCodeToClipboard={this.copyCodeToClipboard.bind(this)} />
                </div>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="row contentAtelier">
                <DisplaySeance detailSeance={this.state.detailSeance} showSeance={this.state.showSeance} showCroquis={this.state.showCroquis} showMateriel={this.state.showMateriel} sequenceSelected={this.state.sequenceSelected} listeSequence={this.state.listeSequence} activiteSelected={this.state.activiteSelected} displayCroquis={this.displayCroquis.bind(this)} displayMateriel={this.displayMateriel.bind(this)} displaySeance2={this.displaySeance2.bind(this)} numBubble={this.state.numBubble}/>
                <DisplayEchauffement detailSeanceEchauffement={this.state.detailSeanceEchauffement} showEchauffement2={this.state.showEchauffement2} selectedEchauffement={this.state.selectedEchauffement} numBubble={this.state.numBubble}/>
                <DisplayCoinMaternelles detailSeanceCoinMaternelles={this.state.detailSeanceCoinMaternelles} showCoinMaternelles2={this.state.showCoinMaternelles2} selectedCoinMaternelles={this.state.selectedCoinMaternelles} numBubble={this.state.numBubble}/>
              </div>
            </div>
            </div> : <div className="eps-empty-state">
              <span className="eps-empty-icon"><FontAwesomeIcon icon={faFolderOpen} aria-hidden="true" /></span>
              <h2>Aucun contenu sélectionné</h2>
              <p>Choisissez un cycle en haut à gauche,<br />puis une ressource pour afficher son contenu ici.</p>
              <div className="eps-skeleton-grid" aria-hidden="true">
                {[1, 2, 3, 4].map((item) => <span className="eps-skeleton-card" key={item}><i /><b /><em /></span>)}
              </div>
            </div>}
          </section>
        </div>
      </main>
    );
  }
}

export default DashboardClass;
